import { getTemporaryLcId, markFilesForUpload } from 'lecture_pages/components/workflows/file-workflow';
import { addTemporaryComponent } from 'redux/actions/lecture-components';
import { AutoGeneratedTranscriptCaptionsSwitch } from 'lecture_pages/components/video/auto-generated-transcript-captions-switch';
import store from 'redux/store';

/* @ngInject */
export default function VideoListEditFormModalController(
  $timeout,
  $uibModalInstance,
  $scope,
  AlertMessages,
  _,
  config,
  vmResolves,
) {
  const vm = this;
  _.extend(vm, vmResolves);

  vm.showLibrary = false;
  vm.lectureComponent.getLibraryVideos(); // to show/hide Video Library link
  vm.allowedFileTypes = vm.lectureComponent.constructor.allowedFileTypes.join(',');
  vm.isContentManagementCollection = vm.CurrentCourseManager.course.isContentManagementCollection;
  vm.config = config;
  $scope.AutoGeneratedTranscriptCaptionsSwitch = AutoGeneratedTranscriptCaptionsSwitch;

  vm.uploadFiles = ($files, $invalidFiles) => {
    if ($invalidFiles && $invalidFiles.length) {
      if ($invalidFiles[0].$error === 'maxSize') {
        AlertMessages.error('FORM.OOPS', 'FILE_UPLOAD.SIZE_EXCEEDED_ALERT', {}, { sizeLimit: $invalidFiles[0].$errorParam });
      } else {
        AlertMessages.error('FORM.OOPS', 'FILE_UPLOAD.NOT_SUPPORTED_ALERT');
      }
    } else if ($files && $files.length) {
      let extension; let
        valid = true;

      valid = _.every($files, (file) => {
        if (file.name.includes('.')) {
          extension = _.last(file.name.split('.'));

          if (!_.contains(vm.lectureComponent.constructor.allowedFileTypes, `.${extension.toLowerCase()}`)) {
            $timeout(() => {
              AlertMessages.error('FORM.OOPS', 'FILE_UPLOAD.NOT_SUPPORTED_ALERT');
            });
            return false;
          }
        }

        return true;
      });

      if (valid) {
        valid = _.every($files, (file) => {
          if (file.size > config.files.videoFileSizeLimitGb * 1024 * 1024 * 1024) {
            $timeout(() => {
              AlertMessages.error('FORM.OOPS', 'FILE_UPLOAD.SIZE_EXCEEDED_ALERT', {}, { sizeLimit: file.$errorParam });
            });
            return false;
          }

          return true;
        });
      }

      if (valid) {
        if (vm.workflowCtx.mode === 'edit') {
          vm.lectureComponent.uploadFiles($files);
        } else {
          const { newComponentIndex } = store.getState().app.lecturePage;
          vm.lectureComponent.id = getTemporaryLcId();
          vm.lectureComponent.index = newComponentIndex;

          store.dispatch(addTemporaryComponent({
            id: vm.lectureComponent.id,
            index: vm.lectureComponent.index,
            trueType: vm.lectureComponent.trueType,
            ...vm.lectureComponent.getPayload(),
          }));
          markFilesForUpload(vm.lecturePageCtx, $files, vm.lectureComponent.id);
        }

        // This 'true' prevents a new component from being made immediately after this modal is closed
        $uibModalInstance.close(true);
      }
    }
  };
}
